import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  fill: "none",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"50\" cy=\"50\" r=\"32\" stroke=\"#ED3C3C\" stroke-width=\"2\"></circle><circle cx=\"50\" cy=\"50\" r=\"28\" fill=\"url(#a)\"></circle><defs><linearGradient id=\"a\" x1=\"50\" x2=\"50\" y1=\"22\" y2=\"78\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#ED3C3C\" stop-opacity=\".5\"></stop><stop offset=\"1\" stop-color=\"#19194D\" stop-opacity=\"0\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render: render }